<template>
    <v-app dark>
        <v-app-bar class="barra" dark app dense fixed>
            <v-app-bar-nav-icon @click="drawerState = !drawerState"
            ></v-app-bar-nav-icon>

            <v-img
                class="mx-3 mt-3"
                :src="require('@/assets/logo-origo-white.png')"
                max-height="80"
                max-width="120"
            ></v-img>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            Olá {{ account }}
            <v-btn icon @click="sair()">
                <v-icon>mdi-logout</v-icon>
            </v-btn>
        </v-app-bar>

        <div class="corner-ribbon" v-if="isDevHml">{{ message }}</div>

        <v-navigation-drawer v-model="drawerState" class="primary" app temporary clipped
                             :style="{ top: $vuetify.application.top + 'px', zIndex: 10, width: '300px' }">

            <menubar></menubar>
        </v-navigation-drawer>
        <v-main>
            <v-container fluid>
                <div class="estornos-banner" v-if="estornos.length > 0 && $route.meta.modulo == 'Balanço Energético'">
                    <div class="estornos-banner__header" @click="estornosBannerAberto = !estornosBannerAberto" style="cursor: pointer;">
                        <v-icon small color="#DB8402" class="mr-2">mdi-alert-circle-outline</v-icon>
                        <span class="estornos-banner__title">{{ estornos.length }} referência(s) com estornos pendentes do Balanço Financeiro</span>
                        <v-icon small class="ml-auto" color="#DB8402">{{ estornosBannerAberto ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </div>
                    <v-expand-transition>
                        <div class="estornos-banner__body" v-if="estornosBannerAberto">
                            <v-chip v-for="estorno in estornos"
                                   :key="estorno.referencia"
                                   small outlined
                                   color="#DB8402"
                                   class="mr-1 mb-1"
                                   @click="irParar('visualizar-balanco-referencia-lista', { referencia: estorno.referencia, consorcio:'Todos' })"
                            >
                                {{ estorno.referencia | formataDataMesAno }} ({{ estorno.contador }})
                            </v-chip>
                        </div>
                    </v-expand-transition>
                </div>
                <flash-message class="myCustomClass" transitionName="fade-transition"></flash-message>

                <transition name="fade-transition">
                    <router-view></router-view>
                </transition>
            </v-container>
        </v-main>
        <!-- Spinner global removido - cada tela controla seu próprio loading -->
        <notifications group="foo"/>

        <v-dialog v-model="confirmSairDialog" max-width="360">
            <v-card class="solis-dialog">
                <v-card-title>
                    <v-icon left color="primary" size="22">mdi-logout</v-icon>
                    Sair
                </v-card-title>
                <v-card-text>Você deseja sair do sistema?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="solis-btn" @click="confirmSairDialog = false">Cancelar</v-btn>
                    <v-btn color="primary" depressed class="solis-btn" @click="confirmarSair">Sair</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="globalConfirmState.visible" max-width="420" persistent>
            <v-card class="solis-dialog">
                <v-card-title>
                    <v-icon left color="primary" size="22">mdi-help-circle-outline</v-icon>
                    {{ globalConfirmState.title }}
                </v-card-title>
                <v-card-text>{{ globalConfirmState.text }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="solis-btn" @click="onConfirmCancel">Cancelar</v-btn>
                    <v-btn color="primary" depressed class="solis-btn" @click="onConfirmOk">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import {logout} from '../plugins/axios'
import menubar from "../components/menubar";
import {confirmDialogState, confirmOk, confirmCancel} from '../mixins/confirmDialog';

export default {
    name: "app",
    components: {menubar},
    data: function () {
        return {
            message: '',
            usuario: {
                nome: ''
            },
            estornos: [],
            estornosBannerAberto: false,
            confirmSairDialog: false,
        }
    },
    computed: {
        globalConfirmState: function () {
            return confirmDialogState;
        },
        drawerState: {
            get() {
                return this.$store.getters['drawer/drawerState'];
            },
            set(v) {
                return this.$store.commit('drawer/toggleDrawerState', v)
            }
        },
        spinnerState: {
            get() {
                return this.$store.getters['spinner/spinnerState'];
            },
        },
        isDevHml() {
            if (process.env.NODE_ENV == 'local') {
                this.message = 'LOCAL';
                return true;
            }

            if (process.env.NODE_ENV == 'dev') {
                this.message = 'DEV';
                return true;
            }

            if (process.env.NODE_ENV == 'homologation') {
                this.message = 'HML';
                return true;
            }

            return false;
        },
        account() {

            if (localStorage.getItem('account')) {
                const account = JSON.parse(localStorage.getItem('account'));

                return account.name;
            }
            return '';
        }

    },
    mounted() {
        this.getDados();
    },
    watch: {
        $route(to, from) {
            this.getEstornos();
        }
    },
    methods: {
        irParar(url, params) {
            this.$router.push({name: url, params: params, query: {
                    estornado: 1
                }})
        },
        sair() {
            this.confirmSairDialog = true;
        },
        confirmarSair() {
            this.confirmSairDialog = false;
            logout();
        },
        onConfirmOk: confirmOk,
        onConfirmCancel: confirmCancel,
        getDados() {
            const vm = this;
        },
        getEstornos(){
          const vm = this

          vm.$store.dispatch('balanco/getEstornosCount')
              .then(function (response) {
                vm.estornos = response.data
              })
                .catch(function (error) {
                })
        }
    }
}

</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css");

.barra {
    background: linear-gradient(135deg, #832472, #16968D) !important;
}

.v-list-item__title {
    color: #FFFFFF !important;
}

.estornos-banner {
    background: #FFF8EC;
    border: 1px solid #FDEACC;
    border-left: 3px solid #DB8402;
    border-radius: 6px;
    margin-bottom: 12px;
    overflow: hidden;
}
.estornos-banner__header {
    display: flex;
    align-items: center;
    padding: 10px 16px;
}
.estornos-banner__header:hover {
    background: rgba(219, 132, 2, 0.04);
}
.estornos-banner__title {
    font-size: 13px;
    font-weight: 600;
    color: #7A5000;
}
.estornos-banner__body {
    padding: 10px 16px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.corner-ribbon {
    width: 200px;
    background: #F26D6E;
    position: fixed;
    top: 25px;
    left: -50px;
    text-align: center;
    line-height: 50px;
    letter-spacing: 1px;
    color: #FFFFFF;
    transform: rotate(-45deg);
    z-index: 99999;
    opacity: 0.6;
    pointer-events: none;
    font-weight: 600;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/app.vue